import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import { AddressTypesActions } from '../actions';
import { NotifierService } from 'angular-notifier';
import { AddressTypesService } from '../../services/address-types.service';

@Injectable()
export class AddressTypesEffects {
  ReadAddressType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AddressTypesActions.ReadAddressType),
      map(action => action),
      switchMap(({ iri }) => {
        return this.service.readAddressType(iri).pipe(
          map(response =>
            AddressTypesActions.ReadAddressTypeSuccess({ response })
          ),
          catchError(response =>
            of(AddressTypesActions.ReadAddressTypeFail({ response }))
          )
        );
      })
    )
  );
  ReadAddressTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AddressTypesActions.ReadAddressTypes),
      map(action => action),
      switchMap(() => {
        return this.service.readAddressTypes().pipe(
          map(response =>
            AddressTypesActions.ReadAddressTypesSuccess({ response })
          ),
          catchError(response =>
            of(AddressTypesActions.ReadAddressTypesFail({ response }))
          )
        );
      })
    )
  );
  FailActions = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          AddressTypesActions.ReadAddressTypeFail,
          AddressTypesActions.ReadAddressTypesFail
        ),
        map(({ type, response }) => {
          console.log({ response });
          const errors = response?.error['hydra:description'];
          let message = 'Fehler';
          switch (type) {
            case AddressTypesActions.READ_ADDRESS_TYPE_FAIL:
              message =
                'Beim Lesen eines AddressTypen sind Fehler aufgetreten:' +
                errors;
              break;
            case AddressTypesActions.READ_ADDRESS_TYPES_FAIL:
              message =
                'Beim Lesen der AddressTypen sind Fehler aufgetreten:' + errors;
              break;
          }
          this.notifierService.show({ type: 'error', message });
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private service: AddressTypesService,
    private notifierService: NotifierService
  ) {}
}
